import * as React from "react";
import { FixedCommentEntries, FixedCommentSetFormModel } from "../types";
import { useFormState } from "informed";
import { map } from "lodash";

import { DragDropContext, Droppable, Draggable, DropResult } from "react-beautiful-dnd";
import { UseOrderedCommentsState } from "./UserOrderedComments";
import FixedCommentEntryFields from "./FixedCommentEntry";


interface FixedCommentEntriesProps extends Omit<UseOrderedCommentsState, "reset">{
    initialEntries: FixedCommentEntries;
    editMode: boolean;
}

const FixedCommentEntries = ({ initialEntries, editMode, add, commentOrder, comments, onDragEnd, remove }: FixedCommentEntriesProps): JSX.Element => {

    const formState = useFormState <FixedCommentSetFormModel>();

    return (

        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="list">
                {provided => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        {map(commentOrder, (key, i) => (comments[key] ? <FixedCommentEntryFields editMode={editMode} index={i} field={`Comments[${key}]`} key={key} initialValue={comments[key]} remove={() => remove(key)} /> : null))}
                        {provided.placeholder}
                        <button id="addNewCommentButton" type="button" className="btn btn-primary btn-outline" onClick={() => add()}>Add New Comment</button>
                    </div>
                )}
            </Droppable>
        </DragDropContext>

    );
};

export default FixedCommentEntries;
